import React, { Component } from "react";
// import { NavLink } from "react-router-dom";
import "./style.css";
class MajorSearch extends Component {
  render() {
    const { placeholder, visible, name, handleVisibleSearch } = this.props;
    return (
      <div
        className={
          visible === true ? "majorSearch_box" : "majorSearch_box display_none"
        }
      >
        <div className="majorSearch_box_div">
          <div className="majorSearch_box_div_img fl">
            <img
              alt=""
              src={require("../../../../../images/search/search_2.png")}
            ></img>
          </div>
          <div className="majorSearch_box_div_input fl">
            <input
              onClick={() => handleVisibleSearch()}
              placeholder={placeholder}
              value={name}
              readOnly
            ></input>
          </div>
        </div>
        {/* <div className="majorSearch_help_div">
          <span>不知道选什么专业？</span>
          <NavLink style={{ color: "#0080fe" }} to="/articledetail/6yBCb">
            必读|手把手教你，填报好80个志愿
          </NavLink>
        </div> */}
      </div>
    );
  }
}

export default MajorSearch;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolMajor/components/MajorSearch/index.js